import React from "react";
import UseGetDashBoardData from "../../../../../Components/Hooks/useDashboardData";
import NuDate from "../../../../../Components/Utils/NuDate";

function OrderDelived() {
  const { data, loading } = UseGetDashBoardData(`/dashboard/order-delivered-recently`);

  return (
    <div className="bg-white p-5 rounded-2xl border border-gray-100 shadow-[0_4px_25px_rgba(0,0,0,0.04)] transition-all duration-300">
      <div className="flex justify-between items-center pb-3 border-b border-gray-100 mb-3">
        <div className="flex items-center space-x-2">
          <div className="w-7 h-7 rounded-lg bg-indigo-50 flex items-center justify-center text-indigo-600">
            <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
              <path strokeLinecap="round" strokeLinejoin="round" d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
          </div>
          <h3 className="text-sm font-semibold text-gray-800">Recent Orders Delivered</h3>
        </div>

        <span className="text-xs font-bold px-2.5 py-0.5 rounded-full bg-indigo-50 text-indigo-700 border border-indigo-200/50">
          Outward Dispatch Feed
        </span>
      </div>

      {loading ? (
        <div className="h-48 flex items-center justify-center animate-pulse">
          <div className="h-32 bg-gray-100 rounded-xl w-full"></div>
        </div>
      ) : (
        <div className="max-h-56 overflow-y-auto pr-1">
          <table className="w-full text-xs">
            <thead className="sticky top-0 bg-gray-50 text-gray-500 font-semibold border-b border-gray-200">
              <tr>
                <th className="py-2 px-2 text-left">Order Ref</th>
                <th className="py-2 px-2 text-left">Customer</th>
                <th className="py-2 px-1 text-center">Shipped Date</th>
                <th className="py-2 px-2 text-right">Status</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-100">
              {data && data.length > 0 ? (
                data.map((item, index) => (
                  <tr key={index} className="hover:bg-gray-50/70 transition-colors">
                    <td className="py-2.5 px-2 font-semibold text-gray-900">{item?.order || "N/A"}</td>
                    <td className="py-2.5 px-2 text-gray-700 truncate max-w-[120px]">{item?.customer || "N/A"}</td>
                    <td className="py-2.5 px-1 text-center text-gray-500 font-medium">
                      {item?.dateShipped ? <NuDate value={item.dateShipped} format="DD MMM YYYY" /> : "N/A"}
                    </td>
                    <td className="py-2.5 px-2 text-right">
                      <span className="text-[10px] font-bold px-2 py-0.5 rounded-full bg-indigo-50 text-indigo-700 border border-indigo-200/50">
                        {item?.status || "Delivered"}
                      </span>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan={4} className="py-6 text-center text-gray-400">
                    No delivered order records available
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}

export default OrderDelived;